export default "/img/SA.03e8de20bafc2812cd4381b62f8e1f14.png";